module.exports = __webpack_public_path__ + "img/goodtimewithscar-4dfa85c4-27e9-476e-ddef-08d959eef549.png";